import React, { useEffect, useState } from "react";
import "../../styles/Industries.css";
import { RiArrowRightSLine } from "react-icons/ri";
import Agriculture_bg_img from "../../bg_images/I_agriculture_bg_img.png";
import { useNavigate } from "react-router-dom";
import { HiArrowNarrowRight } from "react-icons/hi";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";

const Servicecards = [
  {
    title: "Labor Shortages",
    text: " We automate key processes and reduce reliance on manual labor with smart, integrated IT systems. ",
  },
  {
    title: " Sustainability Demands ",
    text: " We optimize water usage, reduce chemical inputs, and improve land management through data-driven insights and precision technologies.",
  },
  {
    title: " Efficiency & Productivity",
    text: " We leverage technology to optimize resource allocation, minimize waste, and improve decision-making for a more productive and profitable farm. ",
  },
  {
    title: " Profitability Pressures ",
    text: " We increase revenue and reduce costs through optimized resource management and streamlined processes. Our solutions help you improve yields, reduce inputs, and access better market opportunities. ",
  },
];

const Agriculture = () => {
  const navigate = useNavigate();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleServicecards, setVisibleServicecards] = useState(3);

  useEffect(() => {
    const updateVisibleServicecards = () => {
      if (window.innerWidth <= 768) {
        setVisibleServicecards(1);
      } else {
        setVisibleServicecards(3);
      }
    };

    updateVisibleServicecards();
    window.addEventListener("resize", updateVisibleServicecards);
    return () =>
      window.removeEventListener("resize", updateVisibleServicecards);
  }, []);

  const handleNext = () => {
    if (currentIndex + visibleServicecards < Servicecards.length) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div className="Industries">
      <div
        className="I_sec1"
        style={{ backgroundImage: `url(${Agriculture_bg_img})` }}
      >
        <h5>
          Industries <RiArrowRightSLine className="servrighticon" /> Agriculture
        </h5>
        <h1> Cultivating Growth with Agriculture Technology</h1>
        <p>
          Facing increasing demands and challenges in modern agriculture? We
          empower your farm and agribusiness with cutting-edge IT solutions to
          optimize every stage of your operations, from field to market.
        </p>
        <button
          onClick={() => navigate("/services/ApplicationDevelopment")}
          className="S_sec1_btn1"
        >
          Discover our solutions
          <HiArrowNarrowRight className="psec1arrow" />
        </button>
      </div>

      {/* Section 2 */}

      <div className="I_sec2">
        <h2>What We Offer Our Customers in the Agriculture Industry</h2>
        <section className="I_sec2_cardsContainer">
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/A_sec2_icon1.svg"
                alt=""
              />
              Smart Farm Management Software
            </h6>
            <p>
              Effortlessly manage your farm operations, from planting to
              harvesting, with intuitive software.{" "}
            </p>{" "}
          </section>{" "}
          <section className="I_sec2_cards">
            {" "}
            <h6>
              {" "}
              <img
                className="I_sec2_icon"
                src="../svg/A_sec2_icon2.svg"
                alt=""
              />
              Precision Agriculture Technologies{" "}
            </h6>{" "}
            <p>
              Utilize sensor data, GPS technology, and analytics to optimize
              irrigation, fertilization, and crop protection.{" "}
            </p>{" "}
          </section>{" "}
          <section className="I_sec2_cards">
            {" "}
            <h6>
              {" "}
              <img
                className="I_sec2_icon"
                src="../svg/A_sec2_icon3.svg"
                alt=""
              />
              AgriTech Data Analytics & Reporting{" "}
            </h6>{" "}
            <p>
              Gain actionable insights into crop health, soil conditions, and
              market trends through comprehensive data analytics.{" "}
            </p>{" "}
          </section>{" "}
          <section className="I_sec2_cards">
            {" "}
            <h6>
              {" "}
              <img
                className="I_sec2_icon"
                src="../svg/A_sec2_icon4.svg"
                alt=""
              />
              Connected Supply Chain Solutions{" "}
            </h6>{" "}
            <p>
              Enhance traceability and efficiency across your agricultural
              supply chain with advanced agritech solutions.{" "}
            </p>{" "}
          </section>{" "}
        </section>{" "}
        <button onClick={() => navigate("/contact")} className="I_sec2_btn1">
          Schedule a free consultation
          <HiArrowNarrowRight className="psec1arrow" />
        </button>
      </div>

      {/* Section 3 */}
      {/* <div className="I_sec3">
        <h2> Solving the Key Challenges in Agriculture </h2>

        <section className="I_sec3_cardsContainer">
          <section>
            <img src="images/I_sec3_leftArrow.png" alt="" />
          </section>
          <section className="I_sec3_cards">
            <h6>Labor Shortages</h6>
            <p>
              We automate key processes and reduce reliance on manual labor with
              smart, integrated IT systems.
            </p>
          </section>
          <section className="I_sec3_cards">
            <h6>Sustainability Demands</h6>
            <p>
              We optimize water usage, reduce chemical inputs, and improve land
              management through data-driven insights and precision
              technologies.
            </p>
          </section>
          <section className="I_sec3_cards">
            <h6>Effeciency & Productivity</h6>
            <p>
              We leverage technology to optimize resource allocation, minimize
              waste, and improve decision-making for a more productive and
              profitable farm.
            </p>
          </section>
          <section>
            <img src="images/I_sec3_rightArrow.png" alt="" />
          </section>
        </section>
      </div> */}

      <div className="S_carousel-container">
        <h2 className="S_carousel-title">
          Solving the Key Challenges in Fintech
        </h2>
        <div className="S_carousel-wrapper">
          <button
            className="arrow left-arrow"
            onClick={handlePrev}
            disabled={currentIndex === 0}
          >
            <MdOutlineKeyboardArrowLeft className="S_rightArrow" />
          </button>

          <div className="S_carousel">
            <div
              className="S_carousel-track"
              style={{
                transform: `translateX(-${
                  currentIndex * (100 / visibleServicecards)
                }%)`,
              }}
            >
              {Servicecards.map((card, index) => (
                <div className="S_carousel-card" key={index}>
                  <h3>{card.title}</h3>
                  <div className="underline"></div>
                  <p>{card.text}</p>
                </div>
              ))}
            </div>
          </div>

          <button
            className="arrow right-arrow"
            onClick={handleNext}
            disabled={currentIndex + visibleServicecards >= Servicecards.length}
          >
            <MdOutlineKeyboardArrowRight className="S_rightArrow" />
          </button>
        </div>
      </div>

      {/* Section 4 */}
      <div className="I_sec4">
        <section className="I_sec4_left">
          <h1>Case Study</h1>
          <h6>
            How Arshil Transformed Operations For A Customer with Agri
            Technology
          </h6>
          <p>
            Learn how Arshil helped an agricultural supply chain company
            revolutionize their operations and streamline communication between
            farmers, employees, and consumers. We built a seamless solution that
            transformed their entire supply chain.
          </p>
        </section>
        <section className="I_sec4_right">
          <img
            className="I_sec4_img1"
            src="../images/I_agri_img2.png"
            alt="agri"
          />
        </section>
      </div>

      {/* Section 5  */}

      <div className="I_sec5">
        <section className="I_sec5_left">
          <h4>Ready to cultivate a more efficient and productive future?</h4>
          <p>
            Partner with us to implement cutting-edge agriculture technology
            solutions and drive your business forward.
          </p>
        </section>
        <section className="I_sec5_right">
          <button onClick={() => navigate("/contact")}>
            Contact Us Today
            <HiArrowNarrowRight className="I_sec5_arrow_right" />
            {/* <MdArrowRightAlt className="I_sec5_arrow_right" /> */}
          </button>
        </section>
      </div>
    </div>
  );
};

export default Agriculture;
